import { Effect, Schema } from "effect";
export const addEncodedIdToStruct = (schema, idGenerator)=>{
    const SchemaWithId = Schema.extend(schema.pipe(Schema.encodedSchema), Schema.Struct({
        id: Schema.String
    }));
    const SchemaFromSchemaWithId = Schema.transformOrFail(SchemaWithId, schema.pipe(Schema.encodedSchema), {
        encode: (to)=>Effect.gen(function*() {
                const id = idGenerator(to);
                const result = {
                    id,
                    ...to
                };
                return result;
            }),
        decode: (from)=>Effect.gen(function*() {
                const { id, ...rest } = from;
                return {
                    ...rest
                };
            }),
        strict: false
    });
    return Schema.compose(SchemaFromSchemaWithId, schema);
};
